/**
 * Rounds a value to 1 decimal place.
 * @param {*} value
 * @returns
 */
export const round1 = (value) =>
  value == null ? null : Math.round(value * 10) / 10;

/**
 * Calculates the mean of an array of values.
 * @param {*} values
 * @returns
 */
export const roundWhole = (value) => (value == null ? null : Math.round(value));

export const mean = (values) =>
  values.length === 0
    ? null
    : values.reduce((sum, value) => sum + value, 0) / values.length;
